import app from "./app";
import environment from "./environment";
import services from "./services";

export default {
  environment,
  services,
  app
};
